import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getModality = async () => {
	const parameter = true;
	const url = `/modalidade?status=${parameter}`;
	const response = await api.get(url);
	return response.data;
};
export const useGetModality = () => {
	return useQuery(['modality-list'], getModality, {
		refetchOnWindowFocus: false,
	});
};
